// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"99ea82f0","354":"fc061151","838":"17fc6081"}[chunkId] + ".js";
};